import { render, staticRenderFns } from "./onReview.vue?vue&type=template&id=6431dc70&scoped=true"
import script from "./onReview.vue?vue&type=script&lang=js"
export * from "./onReview.vue?vue&type=script&lang=js"
import style0 from "./onReview.vue?vue&type=style&index=0&id=6431dc70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6431dc70",
  null
  
)

export default component.exports